<template>
    <div id="sales-init" :class="[$mq]">
        <div class="content">
            <div class="title">{{ $t('sales.init.title', { date: formatDate(date) }) }}</div>
            <div class="subtitle">{{ $t('sales.init.subtitle') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    name: 'Init',
    props: { date: { type: String } },
    data() {
        return {}
    },
    computed: {},
    created() {},
    methods: {
        formatDate(date) {
            if (this.isValidDate(date)) {
                return moment(date).locale(localStorage.language).format('dddd').toUpperCase() + ' ' + moment(date).format('DD/MM')
            } else {
                const localWeekdays = moment.weekdays()
                const englishWeekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

                const weekdayIndex = englishWeekdays.indexOf(date)

                return localWeekdays[weekdayIndex].toUpperCase()
            }
        },
        isValidDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD', true).isValid()
        },
    }
}
</script>
<style lang="scss" scoped>
#sales-init {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 0;
    overflow: hidden;
    white-space: nowrap;
    justify-content: center;

    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 16px;

        .title {
            font-family: $text-bold;
            @include font-size(l);
            margin-bottom: 64px;
            text-align: center;
            margin: 0.8rem 0 1rem 0;
        }
        .subtitle {
            @include font-size(m);
            text-align: center;
            margin-bottom: 40px;
        }

        .btnExit {
            height: 10%;
            margin-top: 40px;
            .btn {
                padding: 0px;
            }
        }
    }
} 

#sales-init.portrait {
    .content {
        .title {
            @include font-size(m);
        }
        .subtitle {
            @include font-size(xs);
        }
    }
}
</style>
